(function ($) {
  holidayshopHotlistsNavFormatterMobileV1 = {
    formatter: $('.holidayshop-hotlists-nav-formatter-mobile-v1')
  };

  Drupal.behaviors.holidayshopHotlistsNavFormatterMobileV1 = {
    get: function (key) {
      return holidayshopHotlistsNavFormatterMobileV1[key];
    },

    set: function (key, val) {
      holidayshopHotlistsNavFormatterMobileV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var hotlistNav = thisFormatter.find('.hotlists-nav');
        var hotlists = thisFormatter.find('.hotlist');

        hotlists.each(function (i) {
          var hotlist = $(this);
          var id = hotlist.attr('id');
          var title = hotlist.find('.hotlist-heading h3').text();
          var hotListHeadingColor = hotlist.find('.hotlist-heading').find('h3, h3 *[style]').filter(':last').css('color');

          hotlist.attr('item', 'hotlist-' + i);
          hotlistNav.append('<a item="hotlist-' + i + '" class="hotlist-tab" href="#' + id + '" style="background-color: ' + hotListHeadingColor + '"><span>' + title + '</span></a>');
        });

        // var topPositionNavOffset = $('#top').height() - 5;
        var topPositionNavOffset = $('#sticky-bar').height() - 5;

        thisFormatter.find('.hotlist-tab').once('hotlist-tab').on('click', function() {
          thisFormatter.find('.hotlist-tab').removeClass('active');
          thisFormatter.find('.hotlist').removeClass('active');
          var item = $(this).attr('item');
          var hotListHeadingColor = thisFormatter.find('.hotlist[item="' + item + '"] .hotlist-heading').find('h3, h3 *[style]').filter(':last').css('color');

          thisFormatter.find('[item="' + item + '"]').addClass('active');
          // hotlistNav.find('a[item="'+item+'"]').not('.active').css({'background': hotListHeadingColor});
          // hotlistNav.find('a[item="'+item+'"].active').css({'background': '#999999'});
          var clickedTabOffset = thisFormatter.find('.hotlist[item="' + item + '"]').offset();
          var clickedTabY = clickedTabOffset.top - $(window).scrollTop();

          // $('body, html').scrollTo((clickedTabY - topPositionNavOffset) + $(window).scrollTop(), {duration: 500, axis: "y"});
          $(function () {
            $('body, html').scrollTo((clickedTabY - topPositionNavOffset) + $(window).scrollTop(), {
              duration: 500,
              axis: 'y'
            });
          });

          return false;
        });

        if (window.location.hash.length !== 0) {
          var hash = window.location.hash;

          thisFormatter.find('.hotlist-tab').removeClass('active');
          thisFormatter.find('.hotlist').removeClass('active');
          var item = thisFormatter.find(hash).attr('item');
          var hotListHeadingColor = thisFormatter.find('.hotlist[item="' + item + '"] .hotlist-heading').find('h3, h3 *[style]').filter(':last').css('color');

          thisFormatter.find('[item="' + item + '"]').addClass('active');
          // hotlistNav.find('a').not('.active').css({ background: ''});
          // hotlistNav.find('a[item="'+item+'"].active').css({'background': hotListHeadingColor});
          var clickedTabOffset = thisFormatter.find('.hotlist[item="' + item + '"]').offset();
          var clickedTabY = clickedTabOffset.top - $(window).scrollTop();

          // $('body, html').scrollTo((clickedTabY - topPositionNavOffset) + $(window).scrollTop(), {duration: 500, axis: "y"});
          $(function () {
            $('body, html').scrollTo((clickedTabY - topPositionNavOffset) + $(window).scrollTop(), {
              duration: 500,
              axis: 'y'
            });
          });
        } else {
          thisFormatter.find('[item="hotlist-0"]').addClass('active').filter('a').css({
            background: thisFormatter.find('.hotlist[item="hotlist-0"].active .hotlist-heading').find('h3, h3 *[style]').filter(':last').css('color')
          });
        }
      });
    }
  };
})(jQuery);
